<template>
  <div class="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-6 gap-4 w-full">

    <!-- Litros Totales Estanque Fijo -->
    <div class="p-4 bg-white rounded-xl shadow border border-gray-100 flex flex-col">
      <p class="text-gray-500 text-xs font-semibold">Litros Totales</p>
      <p class="text-gray-900 text-sm font-medium">Estanque Fijo</p>
      <h2 class="text-2xl font-bold text-blue-600 mt-2">
        {{ Math.round(litrosFijo).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }} L
      </h2>
    </div>

    <!-- Litros Totales Estanque Móvil -->
    <div class="p-4 bg-white rounded-xl shadow border border-gray-100 flex flex-col">
      <p class="text-gray-500 text-xs font-semibold">Litros Totales</p>
      <p class="text-gray-900 text-sm font-medium">Estanque Móvil</p>
      <h2 class="text-2xl font-bold text-green-600 mt-2">
        {{ Math.round(litrosMovil).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }} L
      </h2>
    </div>

    <!-- Litros Totales Estanque MOVIL 2 -->
    <div class="p-4 bg-white rounded-xl shadow border border-gray-100 flex flex-col">
      <p class="text-gray-500 text-xs font-semibold">Litros Totales</p>
      <p class="text-gray-900 text-sm font-medium">Estanque MOVIL 2</p>
      <h2 class="text-2xl font-bold text-teal-600 mt-2">
        {{ Math.round(litrosMovil2).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }} L
      </h2>
    </div>

    <!-- Litros Manuales Estanque Fijo -->
    <div class="p-4 bg-white rounded-xl shadow border border-gray-100 flex flex-col">
      <p class="text-gray-500 text-xs font-semibold">Litros Manuales</p>
      <p class="text-gray-900 text-sm font-medium">Estanque Fijo</p>
      <h2 class="text-2xl font-bold text-red-600 mt-2">
        {{ manualFijo.toLocaleString('es-CL') }} L
      </h2>
    </div>

    <!-- Litros Manuales Estanque Móvil -->
    <div class="p-4 bg-white rounded-xl shadow border border-gray-100 flex flex-col">
      <p class="text-gray-500 text-xs font-semibold">Litros Manuales</p>
      <p class="text-gray-900 text-sm font-medium">Estanque Móvil</p>
      <h2 class="text-2xl font-bold text-orange-600 mt-2">
        {{ manualMovil.toLocaleString('es-CL') }} L
      </h2>
    </div>

    <!-- Litros Manuales Estanque MOVIL 2 -->
    <div class="p-4 bg-white rounded-xl shadow border border-gray-100 flex flex-col">
      <p class="text-gray-500 text-xs font-semibold">Litros Manuales</p>
      <p class="text-gray-900 text-sm font-medium">Estanque MOVIL 2</p>
      <h2 class="text-2xl font-bold text-amber-600 mt-2">
        {{ manualMovil2.toLocaleString('es-CL') }} L
      </h2>
    </div>

  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  datos: { type: Array, default: () => [] },
  manuales: { type: Array, default: () => [] },
  dispositivos: { type: Array, default: () => [] }
});

// Cada tarjeta corresponde a un dispositivo_id fijo del backend
// (/dispositivos). Antes se agrupaba por nombre ("mov"), lo que
// sumaba el Estanque MOVIL 2 dentro del Estanque Móvil.
const ID_FIJO = 1;
const ID_MOVIL = 2;
const ID_MOVIL_2 = 3;

// Solo cuenta dispositivos que el backend informa como configurados.
const idsConfigurados = computed(() =>
  new Set(props.dispositivos.map(d => Number(d.id)))
);

const sumarLitros = (id) =>
  idsConfigurados.value.has(id)
    ? props.datos
      .filter(d => Number(d.dispositivo_id) === id)
      .reduce((t, r) => t + Number(r.litros || 0), 0)
    : 0;

const sumarManuales = (id) =>
  idsConfigurados.value.has(id)
    ? props.manuales
      .filter(d => Number(d.dispositivo) === id)
      .reduce((t, r) => t + Math.abs(Number(r.diferencia_manual || 0)), 0)
    : 0;

// Totales
const litrosFijo = computed(() => sumarLitros(ID_FIJO));
const litrosMovil = computed(() => sumarLitros(ID_MOVIL));
const litrosMovil2 = computed(() => sumarLitros(ID_MOVIL_2));

const manualFijo = computed(() => sumarManuales(ID_FIJO));
const manualMovil = computed(() => sumarManuales(ID_MOVIL));
const manualMovil2 = computed(() => sumarManuales(ID_MOVIL_2));
</script>
